
(function() {
  var result = { translations: { "cs": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hod", "hoursAndMinutes": "{{ hours }} hod {{ minutes }} min", "days": "{{ days }} d", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "days": "{{ days }} d", "hoursAndMinutes": "{{ hours }} h {{ minutes }} m" } }, "dateTime": { "quarterAndYear": "Q {{quarterNumber}}{{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, linka {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "cs": "static-7.858"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.858",
    "ar-eg": "static-7.858",
    "bg": "static-7.858",
    "bn": "static-7.858",
    "ca-es": "static-7.858",
    "cs": "static-7.858",
    "da": "static-7.858",
    "de": "static-7.858",
    "el": "static-7.858",
    "en-gb": "static-7.858",
    "en": "static-7.858",
    "es-mx": "static-7.858",
    "es": "static-7.858",
    "fi": "static-7.858",
    "fr-ca": "static-7.858",
    "fr": "static-7.858",
    "he-il": "static-7.858",
    "hr": "static-7.858",
    "hu": "static-7.858",
    "id": "static-7.858",
    "it": "static-7.858",
    "ja": "static-7.858",
    "ko": "static-7.858",
    "lt": "static-7.858",
    "ms": "static-7.858",
    "nl": "static-7.858",
    "no": "static-7.858",
    "pl": "static-7.858",
    "pt-br": "static-7.858",
    "pt-pt": "static-7.858",
    "ro": "static-7.858",
    "ru": "static-7.858",
    "sk": "static-7.858",
    "sl": "static-7.858",
    "sv": "static-7.858",
    "th": "static-7.858",
    "tl": "static-7.858",
    "tr": "static-7.858",
    "uk": "static-7.858",
    "vi": "static-7.858",
    "x-pseudo": "static-7.858",
    "zh-cn": "static-7.858",
    "zh-hk": "static-7.858",
    "zh-tw": "static-7.858"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:cs', {version: 'static-7.858'}); }
})();


